// extracted by mini-css-extract-plugin
export default {"cookieConsent":"CookieConsent-module--cookieConsent--8f30f","content":"CookieConsent-module--content--869c9","close":"CookieConsent-module--close--286b3"};